import { Link } from 'react-router-dom';
import { PromoCardProps } from '../../../interface/interface';
import { VARIANT_STYLES, CTA_BUTTON_CLASSNAME } from '../../../constant/constant';

const PromoCard = ({
  eyebrow,
  heading,
  description,
  buttonLabel,
  buttonHref,
  imageSrc,
  imageAlt,
  variant = 'cool',
}: Readonly<PromoCardProps>) => {
  const { background, eyebrow: eyebrowColor } = VARIANT_STYLES[variant];

  return (
    <div
      className={`flex h-full flex-col overflow-hidden rounded-2xl md:flex-row ${background}`}
    >
      <div className="flex flex-1 flex-col justify-center gap-3 p-5 md:gap-4 md:p-6 2xl:p-8">
        <span
          className={`text-xs font-semibold uppercase tracking-wide ${eyebrowColor}`}
        >
          {eyebrow}
        </span>

        <h3 className="text-xl font-bold leading-tight text-primary-blue-500 md:text-2xl 2xl:text-3xl">
          {heading}
        </h3>

        <p className="text-sm font-regular leading-relaxed text-grey-600">
          {description}
        </p>

        <div className="mt-1">
          <Link to={buttonHref} className={CTA_BUTTON_CLASSNAME}>
            {buttonLabel}
          </Link>
        </div>
      </div>

      <div className="relative h-56 w-full md:h-auto md:w-[42%]">
        <img
          src={imageSrc}
          alt={imageAlt}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    </div>
  );
};

export default PromoCard;
